"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Badge: function() {
        return _Badge.Badge;
    },
    badgeClassNames: function() {
        return _Badge.badgeClassNames;
    },
    renderBadge_unstable: function() {
        return _Badge.renderBadge_unstable;
    },
    useBadgeStyles_unstable: function() {
        return _Badge.useBadgeStyles_unstable;
    },
    useBadge_unstable: function() {
        return _Badge.useBadge_unstable;
    },
    PresenceBadge: function() {
        return _PresenceBadge.PresenceBadge;
    },
    presenceBadgeClassNames: function() {
        return _PresenceBadge.presenceBadgeClassNames;
    },
    usePresenceBadgeStyles_unstable: function() {
        return _PresenceBadge.usePresenceBadgeStyles_unstable;
    },
    usePresenceBadge_unstable: function() {
        return _PresenceBadge.usePresenceBadge_unstable;
    },
    presenceAwayRegular: function() {
        return _PresenceBadge.presenceAwayRegular;
    },
    presenceAwayFilled: function() {
        return _PresenceBadge.presenceAwayFilled;
    },
    presenceAvailableRegular: function() {
        return _PresenceBadge.presenceAvailableRegular;
    },
    presenceAvailableFilled: function() {
        return _PresenceBadge.presenceAvailableFilled;
    },
    presenceBlockedRegular: function() {
        return _PresenceBadge.presenceBlockedRegular;
    },
    presenceBusyFilled: function() {
        return _PresenceBadge.presenceBusyFilled;
    },
    presenceDndRegular: function() {
        return _PresenceBadge.presenceDndRegular;
    },
    presenceDndFilled: function() {
        return _PresenceBadge.presenceDndFilled;
    },
    presenceOofRegular: function() {
        return _PresenceBadge.presenceOofRegular;
    },
    presenceOfflineRegular: function() {
        return _PresenceBadge.presenceOfflineRegular;
    },
    presenceUnknownRegular: function() {
        return _PresenceBadge.presenceUnknownRegular;
    },
    CounterBadge: function() {
        return _CounterBadge.CounterBadge;
    },
    counterBadgeClassNames: function() {
        return _CounterBadge.counterBadgeClassNames;
    },
    useCounterBadgeStyles_unstable: function() {
        return _CounterBadge.useCounterBadgeStyles_unstable;
    },
    useCounterBadge_unstable: function() {
        return _CounterBadge.useCounterBadge_unstable;
    }
});
const _Badge = require("./Badge");
const _PresenceBadge = require("./PresenceBadge");
const _CounterBadge = require("./CounterBadge");
